// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2Pei5","col":"styles_col__3T1hr","fulfillmentStatus":"styles_fulfillmentStatus__8x2pi","emailCol":"styles_emailCol__N9GVG"};